// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2GAV-","passed":"styles_passed__3nPb5"};